/** SDK version; set at build time or from package.json. */
export const SDK_VERSION = '1.2.0';
